import { Routes, Route, Navigate, BrowserRouter, Outlet, useLocation } from 'react-router-dom'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAuthToken } from 'src/selectors/auth'
import { SignInPage } from 'src/pages/auth/SignInPage'
import { SecureHooksContainer } from './SecureHooksContainer'
import { ROUTES } from './constants/routes'
import { OnboardingsPage } from './pages/dashboard/OnboardingsPage'
import { PaymentsPage } from './pages/dashboard/PaymentsPage'
import { TeamPage } from './pages/dashboard/TeamPage'
import { InviteAcceptPage } from './pages/auth/InviteAcceptPage'
import { SignUpPage } from './pages/auth/SignUpPage'
import { DashboardPage } from './pages/dashboard/DashboardPage'
import { ForgotPasswordPage } from './pages/auth/ForgotPasswordPage'
import { ForgotPasswordLinkSentPage } from './pages/auth/ForgotPasswordLinkSentPage'
import { ResetPasswordPage } from './pages/auth/ResetPasswordPage'
import { SignInAsPage } from './pages/auth/SignInAsPage'
import { ProtectedWithPermission } from './components/shared/ProtectedWithPermission'
import { UserPermission } from './constants/user'
import { NavigateToInitialRoute } from './components/layout/NavigateToInitialRoute'
import { ContractorsPage } from './pages/dashboard/ContractorsPage'
import { ActivitiesDetailsModal } from './components/activities/ActivitiesDetailsModal'
import { CustomerOnboardingPage } from './pages/customer/CustomerOnboardingPage'
import { CustomerOnboardingWrapper } from './components/layout/CustomerOnboardingWrapper'
import { MCOnboardingsPage } from './pages/dashboard/MCOnboardingsPage'
import { ProtectedWithSomePermission } from './components/shared/ProtectedWithSomePermissions'
import { LinkSubcontractorPage } from './pages/dashboard/LinkSubcontractorPage'
import { MCsPage } from './pages/dashboard/MCsPage'
import { MCSignUpPage } from './pages/auth/MCSignUpPage'
import { getIsCustomerOnboarded, getUser } from './selectors/user'
import { FullScreenLoader } from './components/shared/FullScreenLoader'
import { CustomerCollectedDataType, CustomerResubmitInfoType } from './constants/customer/enums'
import { CustomerResubmitBusinessInformationPage } from './pages/customer/customer-resubmit-info/CustomerResubmitBusinessInformationPage'
import { CustomerCompliance } from './components/customer-compliance/CustomerCompliance'
import { CustomerResubmitInsurancePage } from './pages/customer/customer-resubmit-info/CustomerResubmitInsurancePage'
import { CustomerResubmitBusinessDetailsPage } from './pages/customer/customer-resubmit-info/CustomerResubmitBusinessDetailsPage'
import { CustomerResubmitSignContractPage } from './pages/customer/customer-resubmit-info/CustomerResubmitSignContractPage'
import { CustomerResubmitStitchPaymentPage } from './pages/customer/customer-resubmit-info/CustomerResubmitStitchPaymentPage'
import { FetchUser } from './constants/actionTypes'
import { AcceptCustomerInviteSignContractPage } from './pages/mc/AcceptCustomerInviteSignContractPage'
import { SubcontractorRequestsPage } from './pages/dashboard/SubcontractorRequestsPage'
import { ManageTagsModal } from './components/tags/ManageTagsModal'
import { CompleteGigsafeSigningPage } from './pages/customer/CompleteGigsafeSigningPage'
import { CustomerResubmitTSAPage } from './pages/customer/customer-resubmit-info/CustomerResubmitTSAPage'
import { CustomerResubmitPaymentMethodPage } from './pages/customer/customer-resubmit-info/CustomerResubmitPaymentMethodPage'
import { Settings } from './components/settings-config/Settings'
const AuthRoutes = () => (
  <Routes>
    <Route path={ROUTES.INVITE_ACCEPT_URL} element={<InviteAcceptPage />} />
    <Route path={ROUTES.SIGN_UP_URL} element={<SignUpPage />} />
    <Route path={ROUTES.MASTER_CONTRACTORS_SIGN_UP_URL} element={<MCSignUpPage />} />
    <Route path={ROUTES.SIGN_IN_URL} element={<SignInPage />} />
    <Route path={ROUTES.SIGN_IN_AS_URL} element={<SignInAsPage />} />
    <Route path={ROUTES.FORGOT_PASSWORD_URL} element={<ForgotPasswordPage />} />
    <Route path={ROUTES.FORGOT_PASSWORD_LINK_SENT_URL} element={<ForgotPasswordLinkSentPage />} />
    <Route path={ROUTES.RESET_PASSWORD_URL} element={<ResetPasswordPage />} />
    <Route path="*" element={<Navigate to={ROUTES.SIGN_IN_URL} />} />
  </Routes>
)

const OnboardRoutes = () => (
  <>
    <Routes>
      <Route
        path={ROUTES.BASE_URL}
        element={
          <CustomerOnboardingWrapper>
            <Outlet />
          </CustomerOnboardingWrapper>
        }
      >
        <Route index element={<Navigate to={ROUTES.CUSTOMER_ONBOARDING_URL} />} />
        <Route path={ROUTES.CUSTOMER_ONBOARDING_URL} element={<CustomerOnboardingPage />} />
      </Route>
      <Route path={ROUTES.COMPLETE_GIGSAFE_SIGNING_URL} element={<CompleteGigsafeSigningPage />} />
      <Route path={ROUTES.SIGN_IN_AS_URL} element={<SignInAsPage />} />
      <Route path="*" element={<Navigate to={ROUTES.CUSTOMER_ONBOARDING_URL} />} />
    </Routes>
  </>
)

const SecureRoutes = () => {
  const location = useLocation()

  const background = location.state?.background || {
    pathname: ROUTES.CONTRACTOR_ONBOARDINGS_URL,
  }

  const isModal = location.pathname.includes(ROUTES.SETTINGS_URL)

  return (
    <>
      <Routes location={isModal ? background : location}>
        <Route path={ROUTES.BASE_URL} element={<DashboardPage />}>
          <Route index element={<NavigateToInitialRoute />} />
          <Route
            path={ROUTES.CONTRACTOR_ONBOARDINGS_URL}
            element={
              <ProtectedWithPermission withNavigate permission={UserPermission.OnboardingView}>
                <OnboardingsPage />
              </ProtectedWithPermission>
            }
          />
          <Route
            path={ROUTES.PAYMENTS_URL}
            element={
              <ProtectedWithPermission withNavigate permission={UserPermission.PaymentsView}>
                <PaymentsPage />
              </ProtectedWithPermission>
            }
          />
          <Route
            path={ROUTES.CONTRACTORS_URL}
            element={
              // <ProtectedWithPermission withNavigate permission={UserPermission.PaymentsView}>
              <ContractorsPage />
              // </ProtectedWithPermission>
            }
          />
          {/* TODO: add permissions for route */}
          <Route path={ROUTES.LINK_TO_CUSTOMER_URL} element={<LinkSubcontractorPage />} />
          <Route
            path={ROUTES.MASTER_CONTRACTORS_URL}
            element={
              // <ProtectedWithPermission withNavigate permission={UserPermission.PaymentsView}>
              <MCsPage />
              // </ProtectedWithPermission>
            }
          />
          <Route
            path={ROUTES.MASTER_CONTRACTOR_ONBOARDINGS_URL}
            element={
              // <ProtectedWithPermission withNavigate permission={UserPermission.PaymentsView}>
              <MCOnboardingsPage />
              // </ProtectedWithPermission>
            }
          />
          <Route
            path={ROUTES.TEAM_URL}
            element={
              <ProtectedWithSomePermission
                withNavigate
                permissions={[UserPermission.UsersView, UserPermission.InvitesView]}
              >
                <TeamPage />
              </ProtectedWithSomePermission>
            }
          />
          <Route
            path={ROUTES.REQUESTS_URL}
            element={
              // <ProtectedWithPermission
              //   withNavigate
              //   permissions={[UserPermission.UsersView, UserPermission.InvitesView]}
              // >
              <SubcontractorRequestsPage />
              // </ProtectedWithPermission>
            }
          />
          <Route path="*" element={<Navigate to={ROUTES.CONTRACTOR_ONBOARDINGS_URL} />} />
        </Route>
        <Route
          path={ROUTES.CUSTOMER_RESUBMIT_INFO_URL}
          element={
            <CustomerOnboardingWrapper>
              <Outlet />
            </CustomerOnboardingWrapper>
          }
        >
          <Route index element={<Navigate to={ROUTES.BASE_URL} />} />
          <Route
            path={CustomerResubmitInfoType.BusinessInfo}
            element={<CustomerResubmitBusinessInformationPage />}
          />
          <Route
            path={`${CustomerCollectedDataType.Insurance}/:collectedDataId`}
            element={<CustomerResubmitInsurancePage />}
          />
          <Route
            path={CustomerCollectedDataType.BusinessDetails}
            element={<CustomerResubmitBusinessDetailsPage />}
          />
          <Route path={CustomerCollectedDataType.TSA} element={<CustomerResubmitTSAPage />} />
          <Route
            path={CustomerResubmitInfoType.PaymentInfo}
            element={<CustomerResubmitStitchPaymentPage />}
          />
          <Route
            path={CustomerResubmitInfoType.PaymentMethod}
            element={<CustomerResubmitPaymentMethodPage />}
          />
          <Route
            path={CustomerCollectedDataType.GigsafeContract}
            element={<CustomerResubmitSignContractPage />}
          />
        </Route>
        <Route
          path={`${ROUTES.MASTER_CONTRACTOR_ACCEPT_INVITE_URL}/:customerId`}
          element={
            <CustomerOnboardingWrapper>
              <AcceptCustomerInviteSignContractPage />
            </CustomerOnboardingWrapper>
          }
        />
        <Route
          path={ROUTES.COMPLETE_GIGSAFE_SIGNING_URL}
          element={<CompleteGigsafeSigningPage />}
        />
        <Route path={ROUTES.SIGN_IN_AS_URL} element={<SignInAsPage />} />
      </Routes>
      <CustomerCompliance />
      <ActivitiesDetailsModal />
      <SecureHooksContainer />
      <ManageTagsModal />
      <Settings />
    </>
  )
}

export const AppRoutes = () => {
  const dispatch = useDispatch()

  const authToken = useSelector(getAuthToken)
  const user = useSelector(getUser)
  const isOnboarded = useSelector(getIsCustomerOnboarded)

  useEffect(() => {
    if (!authToken) {
      return
    }

    const fetchUser = () => {
      dispatch(FetchUser.request())
    }

    fetchUser()
  }, [authToken])

  return (
    <BrowserRouter>
      {!authToken && <AuthRoutes />}
      {authToken && (
        <>
          {user ? <>{isOnboarded ? <SecureRoutes /> : <OnboardRoutes />}</> : <FullScreenLoader />}
        </>
      )}
    </BrowserRouter>
  )
}
